import React from 'react';
import { Building2, Layers, BrainCircuit, ClipboardCheck, TrendingUp, DoorOpen } from 'lucide-react';
const features = [{
  title: 'Acquire & Partner',
  description: 'We acquire clinics outright or partner with owners who want to stay in the game. Two structures, one playbook.',
  icon: <Building2 className="w-5 h-5 sm:w-6 sm:h-6 text-[#4ECDC4]" data-id="element-157" />
}, {
  title: 'Centralize the Back Office',
  description: 'Legal, credentialing, billing, software, insurance, HR, marketing — all run from ChiroVenture HQ. Your team stops wearing ten hats.',
  icon: <Layers className="w-5 h-5 sm:w-6 sm:h-6 text-[#4ECDC4]" data-id="element-158" />
}, {
  title: 'AI-Powered Operations',
  description: 'We replace back-office headcount with AI-driven systems, not more managers. Lower overhead, tighter margins, faster decisions.',
  icon: <BrainCircuit className="w-5 h-5 sm:w-6 sm:h-6 text-[#4ECDC4]" data-id="element-159" />
}, {
  title: 'Proven Integration Playbook',
  description: 'Standardized 3-phase integration: Red Tape → Systems → Growth. Every clinic runs the same plays, adapted to local context.',
  icon: <ClipboardCheck className="w-5 h-5 sm:w-6 sm:h-6 text-[#4ECDC4]" data-id="element-160" />
}, {
  title: 'Deal Flow & Patient Growth',
  description: 'Built-in patient acquisition engine through our marketing partnership. Every partner clinic plugs in on day one.',
  icon: <TrendingUp className="w-5 h-5 sm:w-6 sm:h-6 text-[#4ECDC4]" data-id="element-161" />
}, {
  title: 'Exit Pathway',
  description: 'We build toward a multi-clinic platform exit. Partners participate in the recap — the second bite is where the real value lives.',
  icon: <DoorOpen className="w-5 h-5 sm:w-6 sm:h-6 text-[#4ECDC4]" data-id="element-162" />
}];
export function StrategicFeatures() {
  return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 relative z-10" data-id="element-163">
      {features.map((feature, index) => <Feature key={feature.title} {...feature} index={index} data-id="element-164" />)}
    </div>;
}
const Feature = ({
  title,
  description,
  icon,
  index
}: {
  title: string;
  description: string;
  icon: React.ReactNode;
  index: number;
}) => {
  return <div className={`
        flex flex-col border-gray-700/50 py-6 sm:py-10 relative group/feature
        ${index % 3 !== 2 ? 'sm:border-r' : ''}
        ${index < 3 ? 'border-b sm:border-b lg:border-b' : ''}
      `} data-id="element-165">
      {index < 3 ? <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-t from-gray-800 to-transparent pointer-events-none" data-id="element-166" /> : <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-b from-gray-800 to-transparent pointer-events-none" data-id="element-167" />}
      <div className="relative mb-3 sm:mb-4 z-10 px-6 sm:px-10 flex items-center gap-3 sm:gap-4" data-id="element-168">
        <span className="text-xl sm:text-2xl font-light text-[#4ECDC4] opacity-50" data-id="element-169">
          {index + 1}
        </span>
        <div data-id="element-170">{icon}</div>
      </div>
      <div className="text-base sm:text-lg font-light mb-2 relative z-10 px-6 sm:px-10" data-id="element-171">
        <div className="absolute left-0 inset-y-0 h-5 sm:h-6 group-hover/feature:h-7 sm:group-hover/feature:h-8 w-1 rounded-tr-full rounded-br-full bg-gray-700 group-hover/feature:bg-[#4ECDC4] transition-all duration-200 origin-center" data-id="element-172" />
        <span className="group-hover/feature:translate-x-2 transition duration-200 inline-block text-white" data-id="element-173">
          {title}
        </span>
      </div>
      <p className="text-xs sm:text-sm text-gray-400 max-w-xs relative z-10 px-6 sm:px-10 font-light" data-id="element-174">
        {description}
      </p>
    </div>;
};